import React from "react";
import { Link } from "react-router-dom";

const PrivacyConsentGate = ({ accepting, onAccept }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4 py-6">
      <div className="bg-white rounded-xl shadow-2xl max-w-lg w-full p-6 space-y-4">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            Accetta la Privacy & Cookie Policy
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Per continuare a utilizzare Planner Turni è necessario accettare la
            nostra{" "}
            <Link
              to="/consensi-privacy"
              target="_blank"
              rel="noopener noreferrer"
              className="text-primary-600 font-medium hover:underline"
            >
              Privacy e Cookie Policy
            </Link>
            . Puoi consultare i dettagli nella pagina dedicata o contattare il
            responsabile della congregazione per maggiori informazioni.
          </p>
        </div>
        <div className="space-y-2 text-sm text-gray-700">
          <p>
            Proseguendo confermi di aver letto e compreso come verranno trattati
            i tuoi dati personali e come funzionano i cookie utilizzati dalla
            piattaforma.
          </p>
          <p>
            Potrai sempre rivedere la policy dalla sezione{" "}
            <Link
              to="/consensi-privacy"
              className="text-primary-600 font-medium hover:underline"
            >
              Consensi Privacy
            </Link>
            .
          </p>
        </div>
        <div className="flex flex-col sm:flex-row sm:justify-end gap-3 pt-2">
          <Link
            to="/consensi-privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="sm:flex-1 text-center px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Leggi la Policy
          </Link>
          <button
            type="button"
            onClick={onAccept}
            disabled={accepting}
            className="sm:flex-1 inline-flex justify-center px-4 py-2 rounded-md text-white bg-primary-600 hover:bg-primary-700 disabled:opacity-60"
          >
            {accepting ? "Salvataggio..." : "Accetto e continuo"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyConsentGate;
